const TOKEN_KEY = "profileToken";
const PROFILE_ID_KEY = "profileId";
const CHOSEN_AT_KEY = "profileChosenAt";

const read = (key: string): string | null => {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
};

const write = (key: string, value: string | null) => {
  try {
    if (value === null) localStorage.removeItem(key);
    else localStorage.setItem(key, value);
  } catch {
    /* private mode; the session still works for this run */
  }
};

let token: string | null = read(TOKEN_KEY);
let profileId: string | null = read(PROFILE_ID_KEY);
let chosenAt: string | null = read(CHOSEN_AT_KEY);
let isSwitching = false;

const listeners = new Set<() => void>();

const emit = () => listeners.forEach((listener) => listener());

export const getProfileToken = () => token;

export const getProfileId = () => profileId;

// Tells "picked the main profile" apart from "has not picked yet": both hold
// no token and no id.
export const getProfileChosenAt = () => chosenAt;

const markChosen = () => {
  chosenAt = String(Date.now());
  write(CHOSEN_AT_KEY, chosenAt);
};

export const getIsProfileSwitching = () => isSwitching;

export const setProfileSwitching = (value: boolean) => {
  if (isSwitching === value) return;
  isSwitching = value;
  emit();
};

export const subscribeProfileSession = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

export const setProfileSession = (id: string, nextToken: string) => {
  profileId = id;
  token = nextToken;
  write(PROFILE_ID_KEY, id);
  write(TOKEN_KEY, nextToken);
  markChosen();
  emit();
};

// Requests without a profile token are the main profile, so it keeps none.
export const setMainProfileSession = () => {
  profileId = null;
  token = null;
  write(PROFILE_ID_KEY, null);
  write(TOKEN_KEY, null);
  markChosen();
  emit();
};

export const expireProfileToken = () => {
  if (!token) return;
  token = null;
  write(TOKEN_KEY, null);
  emit();
};

export const clearProfileSession = () => {
  profileId = null;
  token = null;
  chosenAt = null;
  write(PROFILE_ID_KEY, null);
  write(TOKEN_KEY, null);
  write(CHOSEN_AT_KEY, null);
  emit();
};
